export * as innovationAsset from './innovation-asset'
